<template>
    <modal :title="title" :show.sync="show" :close-show="true">
        <div slot="content">
            <p class="info" v-html=message></p>
            <div v-if="showCheck" class="checkbox">
                <checkbox v-model="checkContact" :data="true">&nbsp;同时彻底删除联系人</checkbox>
            </div>
        </div>
        <div class="footer" slot="footer">
            <a href="javscript:void(0)" class="btn make-sure" @click.prevent="sure">{{okBtnText}}</a>
            <a href="javscript:void(0)" class="btn cancel" @click.prevent="cancel">取消</a>
        </div>
    </modal>
</template>

<script type="text/javascript">
import { checkbox } from '@/components/check'
export default {
    name: 'confirm',
    props: {
        // title: {
        //     type: String,
        //     default: '信息'
        // },
        // message: {
        //     type: String,
        //     default: '信息信息信息信息'
        // },
        // show: {
        //     type: Boolean,
        //     default: false
        // },
        // closeShow: {
        //     type: Boolean,
        //     default: true
        // },
        // okBtnText: {
        //     type: String,
        //     default: '确定'
        // },
        // onSure: {
        //     type: Function
        // },
        // onCancel: {
        //     type: Function
        // },
        // showCheck: {
        //     type: Boolean,
        //     default: false
        // }
    },
    data() {
        return {
            checkContact: false,
            okBtnText:'确定',
            showCheck:false,
            show:true,
            closeShow:true
        }
    },
    components: {
        checkbox
    },
    methods: {
        close() {
            this.show = false
            this.$emit('update:show', false)
        },
        cancel() {
            if (this.onCancel) this.onCancel()
            this.close()
        },
        sure() {
            if (this.onSure) {
                this.onSure(this.checkContact)
                this.close()
            }
        }
    }
}
</script>

<style lang="scss">
.modal {
    .content {
        min-height: 83px;
    }
    .info{
        padding-top: 30px;
    }
    .checkbox {
        margin-bottom: 40px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/confirm.vue